import React from 'react';
import { Box, TextField, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

const LoginForm = ({ handleLogin, needCode }) => {
  const { t } = useTranslation();

  return (
    <Box component="form" onSubmit={handleLogin} noValidate sx={{ width: '100%' }}>
      <TextField
        margin="normal"
        required
        fullWidth
        id="username"
        label={t('login_form.username')}
        name="username"
        autoComplete="username"
        autoFocus
      />
      <TextField
        margin="normal"
        required
        fullWidth
        name="password"
        label={t('login_form.password')}
        type="password"
        id="password"
        autoComplete="current-password"
      />
      {needCode && (
        <TextField
          margin="normal"
          required
          fullWidth
          name="code"
          id="code"
          label={t('login_form.twofa_code', 'Overovací kód (2FA)')}
          autoComplete="one-time-code"
          autoFocus
          inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', maxLength: 6 }}
        />
      )}
      <Button
        type="submit"
        fullWidth
        variant="contained"
        sx={{ mt: 3, mb: 2 }}
      >
        {needCode ? t('login_form.verify', 'Overiť') : t('login_form.sign_in')}
      </Button>
      {/* No register link */}
    </Box>
  );
};

export default LoginForm;
